import { apiService } from './api.js';

export const authService = {
  // Login de usuario
  async login(credentials) {
    try {
      const data = await apiService.request('/auth/login', {
        method: 'POST',
        body: JSON.stringify(credentials),
      });

      if (data.success) {
        apiService.setToken(data.token);
        apiService.setUser(data.user);
      }

      return data;
    } catch (error) {
      throw error;
    }
  },

  // Registro de usuario
  async register(userData) {
    try {
      const data = await apiService.request('/auth/register', {
        method: 'POST',
        body: JSON.stringify(userData),
      });

      return data;
    } catch (error) {
      throw error;
    }
  },

  // Verificar token
  async verify() {
    try {
      const data = await apiService.request('/auth/verify');
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Logout
  async logout() {
    try {
      // Intentar hacer logout en el servidor
      await apiService.request('/auth/logout', {
        method: 'POST',
      });
    } catch (error) {
     // console.error('Error en logout:', error);
    } finally {
      apiService.removeToken();
    }
  },

  // Verificar si el usuario está autenticado
  isAuthenticated() {
    return !!apiService.getToken();
  },

  // Obtener usuario actual
  getCurrentUser() {
    return apiService.getUser();
  },
};